import React from 'react'
import NA from '../not-available'

const AddressView = ({street_address, suburb, postcode, state}) => (
  <section>
    <dl className="details-card-list">
      <dt>Street</dt>
      <dd>{street_address || <NA name="Street" />}</dd>

      <dt>Suburb</dt>
      <dd>{suburb || <NA name="Suburb" />}</dd>

      <dt>Postcode</dt>
      <dd>{postcode || <NA name="Postcode" />}</dd>

      <dt>State</dt>
      <dd>{state || <NA name="State" />}</dd>
    </dl>
  </section>
)

export default AddressView


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/address/view.jsx